import { useEffect } from "react";

// The portal's own name, as set in public/index.html. The tab signal lives in
// the title alone: the site ships a single favicon.ico and no "notify" variant,
// so the icon is left as the page declared it.
const DEFAULT_TITLE = "dobročudan.rs";
const CONSULT_TITLE = "Dolazni poziv | dobročudan.rs";

/**
 * Tab-level attention signals.
 *
 * @param count      pending work items (orders, RFZO requests) shown as a badge
 * @param ringing    an incoming video consult is waiting to be answered. It
 *                   takes over the title instead of joining the badge count: a
 *                   call is answered in seconds or it is lost, and an advisor
 *                   scanning a strip of background tabs has to be able to tell
 *                   it apart from a queue that can wait.
 */
export const useTabNotifications = (count: number, ringing = false) => {
  useEffect(() => {
    document.title = ringing
      ? CONSULT_TITLE
      : count > 0
      ? `(${count}) ${DEFAULT_TITLE}`
      : DEFAULT_TITLE;

    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [count, ringing]);
};
